// import database from "./db"
import { async } from "q"
import indexedDB from "./indexedDB"
// import global from "./global"

/**
 * 新增数据
 * @param {string} tableName 表名称
 * @param {object} obj 数据
 * @param {boolean} isCloseDB 是否关闭数据库
 */
export async function insertData(tableName, obj, isCloseDB) {
    return new Promise((resolve,reject) => {
        indexedDB.openIndexedDB().then( db => {
            // 建立读写事务,向对象仓库写入数据记录
            let request = db.transaction([tableName], 'readwrite').objectStore(tableName).add(obj)
            request.onsuccess = event => {
                // console.log('数据写入'+ tableName + '表成功: ',event);
                if (isCloseDB) {
                    indexedDB.closeDB(db)
                }
                resolve(event)
            }
            request.onerror = event => {
                // console.log('数据写入失败');
                if (isCloseDB) {
                    indexedDB.closeDB(db)
                }
                reject()
            }
        })
    })
}

/**
 * 查询数据 查询所有数据
 * @param {string} tableName 表名称
 */
export async function queryAllList(tableName) {
    return new Promise((resolve,reject) => {
        indexedDB.openIndexedDB().then( db => {
            let list = []
            let store = db
            .transaction([tableName], 'readwrite') // 食物
            .objectStore(tableName) // 参考对象
            let request = store.openCursor() // 指针对象
            // 游标开启成功，逐行读数据
            request.onsuccess = function (event) {
            let cursor = event.target.result
            if (cursor) {
                // 必须要检查
                list.push(cursor.value)
                cursor.continue()
            } else {
                // console.log('游标读取'+ tableName +'表的数据：', list)
                resolve({data: list})
            }
            }
            request.onerror = function (event) {
                // console.log('获取列表失败')
                reject()
            }
          }  
        )
    })
}

/**
 * 通过主键读取数据
 * @param {string} tableName 仓库名称
 * @param {string} key 主键值
 */
export async function queryByKey(tableName, key) {
    return new Promise((resolve, reject) => {
        indexedDB.openIndexedDB().then( db => {
            var transaction = db.transaction([tableName]); // 事务
            var objectStore = transaction.objectStore(tableName); // 仓库对象
            var request = objectStore.get(key); // 通过主键获取数据
        
            request.onerror = function (event) {
                // console.log("事务失败");
            };
        
            request.onsuccess = function (event) {
                // console.log("主键查询结果: ", request.result);
                resolve(request.result);
            };
        })
    });
  }

/**
 * 条件查询
 * @param {string} tableName 表名称
 * @param {string} key 字段名
 * @param {string} value 字段值
 */
export async function queryBy(tableName, key, value) {
    return new Promise((resolve,reject) => {
        indexedDB.openIndexedDB().then( db => {
            let list = []
            let store = db
            .transaction([tableName], 'readwrite') // 食物
            .objectStore(tableName) // 参考对象
            // 单索引
            let result = store.index(key);
            // 打开游标
            let request = result.openCursor(IDBKeyRange.only(value));	//条件查询
            // 游标开启成功，逐行读数据
            request.onsuccess = function (event) {
                let cursor = event.target.result
                if (cursor) {
                    // 必须要检查
                    list.push(cursor.value)
                    cursor.continue()
                } else {
                    // console.log('游标读取'+ tableName +'表的'+ key +'字段数据：', list)
                    indexedDB.closeDB(db)
                    resolve({data: list})
                }
            }
            request.onerror = function (event) {
                // console.log('获取列表失败')
                indexedDB.closeDB(db)
                reject()
            }
        })
    })
}
/**
 * 更新数据
 * @param {string} tableName 仓库名称
 * @param {object} obj 数据
 */
export async function updateData(tableName, obj) {
    return new Promise((resolve,reject) => {
        indexedDB.openIndexedDB().then( db => {
            // 建立读写事务,向对象仓库写入数据记录
            let request = db.transaction([tableName], 'readwrite').objectStore(tableName).put(obj)
            request.onsuccess = event => {
                // console.log('数据更新'+ tableName + '表成功: ',event);
                indexedDB.closeDB(db)
                resolve(event)
            }
            request.onerror = event => {
                // console.log('数据更新失败');
                indexedDB.closeDB(db)
                reject()
            }
        })
    })
}


/**
 * 通过主键删除数据
 * @param {string} storeName 仓库名称
 * @param {object} id 主键值
 */
export async function deleteData(tableName, id) {
    return new Promise((resolve,reject) => {
        indexedDB.openIndexedDB().then( db => {
            // 建立读写事务,向对象仓库写入数据记录
            let request = db.transaction([tableName], 'readwrite').objectStore(tableName).delete(id)
            request.onsuccess = event => {
                // console.log('数据删除成功');
                resolve(event)
            }
            request.onerror = event => {
                // console.log('数据删除失败');
                reject()
            }
        })
    })
}

/**
 * 条件删除
 * @param {string} tableName 表名称
 * @param {string} key 字段名
 * @param {string} value 字段值
 */
export async function deleteBy(tableName, key, value) {
  return new Promise((resolve,reject) => {
      indexedDB.openIndexedDB().then( db => {
          let store = db
          .transaction([tableName], 'readwrite') // 食物
          .objectStore(tableName) // 参考对象
          // 单索引
          let result = store.index(key);
          // 打开游标
          let request = result.openCursor(IDBKeyRange.only(value));	//条件查询
          // 游标开启成功，逐行读数据
          request.onsuccess = function (event) {
              let cursor = event.target.result
              if (cursor) {
                  console.log(tableName + '_id: ', cursor.key)
                  console.log('删除:',tableName, key, value)
                  cursor.delete()
                  cursor.continue()
              } else {
                  // console.log('游标读取'+ tableName +'表的'+ key +'字段数据：', list)
                  indexedDB.closeDB(db)
                  resolve(event)
              }
          }
          request.onerror = function (event) {
              // console.log('获取列表失败')
              indexedDB.closeDB(db)
              reject()
          }
      })
  })
}

// 字符串下划线转驼峰
function formatToHump(value) {
  return value.replace(/\_(\w)/g, (_, letter) => letter.toUpperCase())
} 




// WEBPACK FOOTER //
// ./src/assets/js/sql.js